const TranslatedPostComment = ({
  translatedText,
  handleTranslate,
}: {
  text?: string;
  translatedText?: string;
  handleTranslate: (translatedText: string) => void;
}) => {
  return (
    <div>
      {translatedText}
      <div className="flex items-end">
        {translatedText && (
          <div onClick={() => handleTranslate("")}>
            <span className="text-gray-50 text-sm">Cancel</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TranslatedPostComment;
